<template>
  <!--  mobile nav -->
  <nav>
    <div class="md:hidden">
      <header
        class="fixed inset-0 z-[40] h-[4.5rem] mb-20 border-b bg-primary border-[var(--chat-input-border)] flex items-center justify-between px-4"
      >
        <div class="fixed top-4 left-4 right-4 flex items-center gap-3">
          <!-- hamburger -->
          <button
            type="button"
            class="w-11 h-11 flex items-center justify-center rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
            @click="toggleMobile"
            aria-label="Menu openen"
          >
            <span class="relative w-6 h-3">
              <span
                class="absolute left-0 top-0 w-full h-[2px] bg-current rounded-xl transition-[top,transform] duration-[800ms] ease-in-out"
              ></span>
              <span
                class="absolute left-0 bottom-0 w-full h-[2px] bg-current rounded-xl transition-[bottom,transform] duration-[800ms] ease-in-out"
              ></span>
            </span>
          </button>
          <h1 class="text-base font-medium">
            CAOBOT<span class="text-[#7e57c2] ml-2">.</span>
          </h1>
        </div>
      </header>

      <div
        class="z-[100] fixed top-0 left-0 h-full w-[350px] bg-[var(--sidebar-background)] transition-transform duration-[800ms] ease-in-out will-change-transform overflow-hidden"
        :class="mobileOpen ? 'translate-x-0' : '-translate-x-full'"
      >
        <div class="h-full overflow-y-auto custom-scrollbar">
          <header
            class="fixed top-0 inset-x-0 z-50"
          >
          <div class="absolute inset-0 -top-5 -bottom-1 bg-gradient-to-b from-[#ffffff] dark:from-[#212121] from-[80%] to-transparent blur-md"></div>
            <div
              class="relative flex flex-row-reverse justify-between px-6 py-4"
            >
              <!-- kruisje -->
              <button
                type="button"
                class="w-11 h-11 flex items-center justify-center rounded-xl hover:bg-black/10 dark:hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
                @click="toggleMobile"
                aria-label="Menu sluiten"
              >
                <span class="relative w-6 h-4">
                  <span
                    class="absolute left-0 top-1/2 w-full h-[2px] bg-current rounded-xl transition-[top,transform] duration-[800ms] ease-in-out"
                    :class="[
                      mobileOpen
                        ? 'top-1/2 -translate-y-1/5 rotate-45 delay-[500ms]'
                        : 'delay-0',
                    ]"
                  ></span>
                  <span
                    class="absolute left-0 top-1/2 w-full h-[2px] bg-current rounded-xl transition-[top,transform] duration-[800ms] ease-in-out"
                    :class="[
                      mobileOpen
                        ? 'top-1/2 translate-y-1/5 -rotate-45 delay-[500ms]'
                        : 'delay-0',
                    ]"
                  ></span>
                </span>
              </button>
              <div class="flex items-center gap-x-2">
                <UiIcon
                  name="custom-icons:violet"
                  class="text-[var(--color-mode-text)]"
                  size="lg"
                />
                <h1 class="text-base font-medium truncate">
                  CAOBOT<span class="text-[#7e57c2] ml-2">.</span>
                </h1>
              </div>
            </div>
          </header>
          <div class="flex-1 min-h-0 px-6 pt-16 pb-4">
            <div class="relative group mt-4">
              <UiButton
                label="Recente chats zoeken"
                icon="custom-icons:search"
                icon-position="left"
                iconSize="md"
                class="rounded-[87px] btn w-full justify-start translate-x-[-11px] pr-4 p-2 text-sm flex items-center gap-1 leading-none hover:bg-black/15 dark:hover:bg-white/15 whitespace-nowrap"
                @click="openSearch"
              />

              <span
                v-if="showSearchTooltip"
                class="pointer-events-none absolute right-6 top-1/2 -translate-y-1/2 text-xs px-2 py-1 rounded-lg bg-black/10 dark:bg-white/10 text-[var(--color-mode-text)] opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
                aria-hidden="true"
              >
                {{ imdac ? "⌘ K" : "Ctrl K" }}
              </span>
            </div>
            <UiButton
              class="rounded-[87px] btn w-full justify-start translate-x-[-11px] p-2 mt-2 mb-8 text-sm flex items-center gap-1 leading-none hover:bg-black/15 dark:hover:bg-white/15"
              label="Nieuwe chat"
              icon="custom-icons:pen"
              icon-position="left"
              iconSize="md"
              to="/"
            />
            <!-- Chats expanded -->
            <div>
              <p class="text-[#7B7B7B] dark:text-[#888888]">Chats</p>

              <div 
                v-if="userStore.chats.length > 0"
                class="relative flex-1 min-h-0 my-4"
              >
                <div class=" h-full custom-scrollbar">
                  <ul class="flex-1 h-full">
                    <RecentChat
                      v-for="chat in userStore.chats"
                      :key="chat.id"
                      :chat-preview="chat"
                      @delete="handleDeleteChat"
                      @rename="handleRenameChat"
                      class="first:relative"
                      :isOpen="openMenuId === chat.id"
                      @toggleMenu="handleToggleMenu"
                    />
                  </ul>
                </div>
              </div>
              <div v-else class="p-4 text-center">Geen chats gevonden.</div>
            </div>
          </div>
          <footer
            class="sticky left-0 bottom-0 h-20 w-full bg-[var(--sidebar-background)] z-20 shrink-0 py-2 px-3"
          >
            <div
              class="pointer-events-none absolute inset-x-0 -top-10 h-10 bg-gradient-to-t from-[var(--sidebar-background)] to-transparent"
            ></div>

            <div
              class="absolute top-1/2 left-8 -translate-y-1/2 flex items-center gap-4"
            >
              <UiUserBadge
                variant="collapsed"
                :username="userStore.username"
                :subscription-name="userStore.subscription.name"
                @click="() => {}"
                @action="handleProfileAction"
              />
            </div>
          </footer>
        </div>
      </div>
    </div>
    <Transition name="backdrop">
      <div
        v-if="mobileOpen"
        class="fixed inset-0 bg-black/40 backdrop-blur-xs z-[90]"
        @click="toggleMobile"
      ></div>
    </Transition>
  </nav>

  <aside
    ref="sidebarEl"
    :style="{ width: targetWidth + 'px', minWidth: targetWidth + 'px' }"
    :class="[
      'hidden md:flex relative z-[60] flex-col bg-[var(--sidebar-background)] color-mode-text h-screen border-r-[1px] border-r-[var(--color-mode-border)]',
      !isDragging &&
        (userStore.isCollapsed
          ? 'transition-[width,min-width] duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] will-change-[width,min-width]'
          : 'transition-[width,min-width] duration-[1000ms] ease-[cubic-bezier(0.16,1,0.3,1)] will-change-[width,min-width]'),
    ]"
  >
    <!-- We renderen TWEE lagen (collapsed + expanded) tegelijk.
      Alleen opacity/pointer-events wisselen  -->

    <div class="relative flex-1">
      <!-- =========================
           COLLAPSED LAYER
           ========================= -->
      <div
        class="absolute inset-0 flex flex-col transition-opacity duration-150 ease-out"
        :class="[
          uiMode === 'collapsed' || uiMode === 'collapsing'
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none',
        ]"
      >
        <!-- Header collapsed: logo = expand button + tooltip  -->
        <header class="shrink-0 pt-6 pb-2">
          <button
            type="button"
            class="group relative w-full flex justify-center"
            @click="toggleSidebar"
            aria-label="Sidebar uitklappen"
          >
            <!-- vaste ankerbreedte  -->
            <span
              class="relative w-11 h-11 grid place-items-center rounded-xl group-hover:bg-black/10 dark:group-hover:bg-white/10 transition-colors duration-150"
            >
              <!-- Logo (default)  -->
              <UiIcon
                name="custom-icons:violet"
                class="text-[var(--color-mode-text)] transition-opacity duration-150 group-hover:opacity-0 group-focus-visible:opacity-0"
                size="md"
              />
              <!-- Expand icon (shown on hover like ChatGPT)  -->
              <UiIcon
                name="custom-icons:uitklappen"
                class="absolute inset-0 m-auto text-[var(--color-mode-text)] opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100"
                size="md"
              />

              <!-- Tooltip -->
              <span
                class="pointer-events-none absolute left-[calc(100%+10px)] top-1/2 -translate-y-1/2 whitespace-nowrap text-xs px-2 py-1 rounded-lg bg-black text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100"
                aria-hidden="true"
              >
                Sidebar uitklappen
              </span>
            </span>
          </button>
        </header>

        <!-- Actions collapsed: icon buttons onder logo -->
        <div class="shrink-0 pt-0">
          <div class="flex flex-col items-center gap-3 mt-5">
            <UiButton
              type="button"
              class="group relative grid place-items-center w-11 h-11 rounded-xl hover:bg-black/10 dark:hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
              @click="openSearch"
              aria-label="Recente chats zoeken"
              icon="custom-icons:search"
              icon-size="md"
              icon-position="center"
            >
              <span
                class="pointer-events-none absolute left-[calc(100%+10px)] top-1/2 -translate-y-1/2 whitespace-nowrap text-xs px-2 py-1 rounded-lg bg-black text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100"
                aria-hidden="true"
              >
                Recente chats zoeken
                <span class="ml-2 opacity-80">{{
                  imdac ? "⌘ K" : "Ctrl K"
                }}</span>
              </span>
            </UiButton>

            <UiButton
              to="/"
              class="group relative grid place-items-center w-11 h-11 rounded-xl hover:bg-black/10 dark:hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
              aria-label="Nieuwe chat"
              icon="custom-icons:pen"
              icon-size="md"
              icon-position="center"
            >
              <span
                class="pointer-events-none absolute left-[calc(100%+10px)] top-1/2 -translate-y-1/2 whitespace-nowrap text-xs px-2 py-1 rounded-lg bg-black text-white opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100"
                aria-hidden="true"
              >
                Nieuwe chat
              </span>
            </UiButton>
          </div>
        </div>

        <!-- Footer collapsed: altijd onderaan -->
        <footer class="mt-auto pb-12">
          <div class="flex flex-col items-center gap-4">
            <UiUserBadge
              variant="collapsed"
              :username="userStore.username"
              :subscription-name="userStore.subscription.name"
              @click="() => {}"
              @action="handleProfileAction"
            />
          </div>
        </footer>
      </div>

      <!-- =========================
           EXPANDED LAYER (oude layout)
           =========================  -->
      <div
        class="absolute inset-0 flex flex-col transition-opacity duration-200 ease-out"
        :class="[
          uiMode === 'expanded' || uiMode === 'expanding'
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none',
        ]"
        :aria-hidden="!(uiMode === 'expanded' || uiMode === 'expanding')"
      >
        <!-- Header expanded: exact zoals je oude UI  -->
        <header
          class="shrink-0 flex items-center justify-between pt-8 pb-2 pr-[2em] pl-[32px]"
        >
          <div class="flex items-center gap-4 min-w-0">
            <UiIcon
              name="custom-icons:violet"
              class="text-[var(--color-mode-text)] shrink-0"
              size="md"
            />
            <h1 class="text-base font-medium">
            CAOBOT<span class="text-[#7e57c2] ml-2">.</span>
          </h1>
          </div>

          <UiIcon
            name="custom-icons:inklappen"
            class="cursor-pointer shrink-0"
            size="md"
            @click="toggleSidebar"
            aria-label="Sidebar inklappen"
          />
        </header>

        <!-- Actions expanded: oude big buttons -->
        <div class="shrink-0 pr-[2em] pl-[32px]">
          <div class="relative group mt-8">
            <UiButton
              label="Recente chats zoeken"
              icon="custom-icons:search"
              icon-position="left"
              iconSize="md"
              class="rounded-[87px] btn w-full justify-start translate-x-[-11px] pr-4 p-2 text-sm flex items-center gap-1 leading-none hover:bg-black/15 dark:hover:bg-white/15 whitespace-nowrap"
              @click="openSearch"
            />

            <span
              v-if="showSearchTooltip"
              class="pointer-events-none absolute right-6 top-1/2 -translate-y-1/2 text-xs px-2 py-1 rounded-lg bg-black/10 dark:bg-white/10 text-[var(--color-mode-text)] opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
              aria-hidden="true"
            >
              {{ imdac ? "⌘ K" : "Ctrl K" }}
            </span>
          </div>

          <UiButton
            class="rounded-[87px] btn w-full justify-start translate-x-[-11px] p-2 mt-2 mb-4 text-sm flex items-center gap-1 leading-none hover:bg-black/15 dark:hover:bg-white/15"
            label="Nieuwe chat"
            icon="custom-icons:pen"
            icon-position="left"
            iconSize="md"
            to="/"
          />
        </div>

        <!-- Chats expanded -->
        <div
          class="flex-1 min-h-0 flex flex-col border-t border-[var(--primary)] dark:border-[var(--primary-lighter)] pt-4"
        >
          <p class="text-[#7B7B7B] dark:text-[#888888] pl-[32px]">Chats</p>

          <div
            v-if="userStore.chats.length > 0"
            class="relative flex-1 min-h-0 my-4"
          >

            <div class="overflow-y-auto h-full custom-scrollbar">
              <ul class="px-[20px] pb-[20px] flex-1 h-full">
                <RecentChat
                  v-for="chat in userStore.chats"
                  :key="chat.id"
                  :chat-preview="chat"
                  @delete="handleDeleteChat"
                  @rename="handleRenameChat"
                  class="first:relative z-50"
                  :isOpen="openMenuId === chat.id"
                  @toggleMenu="handleToggleMenu"
                />
              </ul>
            </div>
          </div>
          <div v-else class="p-4 text-center">Geen chats gevonden.</div>
        </div>

        <!-- Footer expanded  -->
        <footer class="z-20 h-20">
          <div
            class="pointer-events-none absolute inset-x-0 bottom-20 h-10 bg-gradient-to-t from-[var(--sidebar-background)] to-transparent"
          ></div>

          <div
            class="h-auto flex items-center gap-24 shrink-0 pl-[32px] pt-[16px]"
          >
            <UiUserBadge
              variant="expanded"
              :username="userStore.username"
              :subscription-name="userStore.subscription.name"
              class="shrink-0"
              @click="() => {}"
              @action="handleProfileAction"
            />
          </div>
        </footer>

        <!-- Violet88-branding: gecentreerd onderaan, badge blijft op z'n plek -->
        <p
          class="pointer-events-none absolute inset-x-0 bottom-1 z-30 text-center text-[11px] leading-none text-neutral-500"
        >
          een product van
          <a
            href="https://www.violet88.nl/"
            target="_blank"
            rel="noopener noreferrer"
            class="pointer-events-auto underline underline-offset-2 transition hover:text-[var(--color-mode-text)]"
            >Violet88</a
          >
        </p>

        <!-- Resize handle (alleen expanded) -->
        <div
          class="absolute top-0 right-0 h-full w-2 translate-x-1/2 cursor-col-resize z-50"
          @mousedown.stop.prevent="startDrag"
        ></div>
      </div>
    </div>
  </aside>

  <SearchChatModal
    :open="isSearchOpen"
    :chats="userStore.chats"
    @close="closeSearch"
  />
</template>

<script setup lang="ts">
const config = useRuntimeConfig();
const userStore = useUserStore();
const router = useRouter();

const openMenuId = ref<string | null>(null);
const handleToggleMenu = (id: string) => {
  openMenuId.value = openMenuId.value === id ? null : id;
};

const sidebarEl = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const sidebarWidth = ref(userStore.sidebarWidth);
const COLLAPSED_WIDTH = 74;

// UI state machine
const uiMode = ref<"collapsed" | "expanding" | "expanded" | "collapsing">(
  userStore.isCollapsed ? "collapsed" : "expanded",
);

const targetWidth = computed(() =>
  userStore.isCollapsed ? COLLAPSED_WIDTH : sidebarWidth.value,
);

/// mobile nav////
const mobileOpen = ref(false);

const toggleMobile = () => {
  mobileOpen.value = !mobileOpen.value;
};

watch(
  () => router.currentRoute.value.fullPath,
  () => {
    mobileOpen.value = false;
  },
);

const toggleSidebar = () => {
  const el = sidebarEl.value;

  if (userStore.isCollapsed) {
    uiMode.value = "expanding";

    requestAnimationFrame(() => {
      userStore.toggleCollapse(); // isCollapsed -> false
    });

    if (!el) return;

    const onEnd = (e: TransitionEvent) => {
      if (e.propertyName !== "width") return;
      el.removeEventListener("transitionend", onEnd);
      uiMode.value = "expanded";
    };
    el.addEventListener("transitionend", onEnd);
  } else {
    uiMode.value = "collapsing";
    userStore.toggleCollapse(); // isCollapsed -> true

    if (!el) {
      uiMode.value = "collapsed";
      return;
    }

    const onEnd = (e: TransitionEvent) => {
      if (e.propertyName !== "width") return;
      el.removeEventListener("transitionend", onEnd);
      uiMode.value = "collapsed";
    };
    el.addEventListener("transitionend", onEnd);
  }
};

const showSearchTooltip = computed(() => sidebarWidth.value >= 315);

let startX = 0,
  startWidth = 0,
  grabOffset = 0;

function onDrag(e: MouseEvent) {
  if (!isDragging.value) return;
  const newWidth = startWidth + (e.clientX - startX) - grabOffset;
  sidebarWidth.value = Math.max(321, Math.min(600, newWidth));
}

function startDrag(e: MouseEvent) {
  const rect = sidebarEl.value?.getBoundingClientRect();
  if (!rect) return;

  const distanceToRight = Math.abs(rect.right - e.clientX);
  if (distanceToRight > 8) return;

  isDragging.value = true;
  grabOffset = e.clientX - rect.right;
  startX = e.clientX;
  startWidth = sidebarWidth.value;

  document.body.style.userSelect = "none";
  document.body.style.cursor = "col-resize";

  window.addEventListener("mousemove", onDrag);
  window.addEventListener("mouseup", stopDrag);
}

function stopDrag() {
  if (!isDragging.value) return;

  isDragging.value = false;
  document.body.style.userSelect = "";
  document.body.style.cursor = "";

  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);

  userStore.setSidebarCookie(sidebarWidth.value);
}

// --- rest van je bestaande logic ---
try {
  const result = await $fetch<ChatListItem[]>(
    `${config.public.baseURL}/api/chat`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${userStore.apiKey}`,
      },
    },
  );

  if (Array.isArray(result) && userStore.chats.length === 0) {
    result.forEach((chat) =>
      userStore.chats.push({
        id: chat.id,
        title: chat.title,
        created_at: chat.created_at,
        link: `/chat/${chat.id}`,
      }),
    );
  }
} catch (e) {
  console.error(e);
}

const handleDeleteChat = async (chatId: string) => {
  try {
    const res = await fetch(`${config.public.baseURL}/api/chat/${chatId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: userStore.apiKey ? `Bearer ${userStore.apiKey}` : "",
      },
    });

    if (!res.ok && res.status !== 204) {
      throw new Error(`Failed to delete chat: ${res.statusText}`);
    }

    if (userStore.chats) {
      userStore.chats = userStore.chats.filter((chat) => chat.id !== chatId);
    }

    const rawId = router.currentRoute.value.params.id;
    const currentId = Array.isArray(rawId) ? rawId[0] : rawId;

    if (currentId === chatId) {
      router.replace("/");
    }
  } catch (err) {
    console.error(err);
  }
};

const handleRenameChat = async ({
  id,
  title,
}: {
  id: string;
  title: string;
}) => {
  try {
    const res = await fetch(`${config.public.baseURL}/api/chat/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: userStore.apiKey ? `Bearer ${userStore.apiKey}` : "",
      },
      body: JSON.stringify({ title }),
    });

    if (!res.ok) {
      throw new Error(`Failed to rename chat: ${res.statusText}`);
    }

    const chat = userStore.chats.find((c) => c.id === id);
    if (chat) chat.title = title.trim() || "Nieuwe chat";
  } catch (err) {
    console.error(err);
  }
};

const logout = async () => {
  await userStore.logout();
  router.push("/login");
};

const isSearchOpen = ref(false);
const openSearch = () => {
  isSearchOpen.value = true;
  openMenuId.value = null;
};
const closeSearch = () => (isSearchOpen.value = false);

function onGlobalKeydown(e: KeyboardEvent) {
  const k = e.key.toLowerCase();
  const metaOrCtrl = imdac.value ? e.metaKey : e.ctrlKey;
  if (metaOrCtrl && k === "k") {
    e.preventDefault();
    openSearch();
  }
}
onMounted(() => window.addEventListener("keydown", onGlobalKeydown));
onBeforeUnmount(() => window.removeEventListener("keydown", onGlobalKeydown));

const imdac = computed(() => {
  if (typeof navigator === "undefined") return false;
  const uaData = (navigator as any).userAgentData;
  if (uaData?.platform) return uaData.platform === "macOS";
  return /Mac|iPhone|iPad|iPod/i.test(navigator.userAgent);
});

/**
 *
 * @param action
 */
const handleProfileAction = (action: string) => {
  switch (action) {
    case "logout":
      logout();
      break;
    case "settings":
      router.push("/settings");
      break;
    case "upgrade":
      router.push("/upgrade");
      break;
    case "feedback":
      // open modal later
      break;
    case "help": {
      const tawk = (window as any).Tawk_API;
      if (!tawk) break;
      if (tawk.isChatMaximized?.()) {
        tawk.minimize?.();
      } else {
        tawk.maximize?.();
        tawk.onChatMinimized = function () {
          if (window.innerWidth < 768) tawk.hideWidget?.();
        };
      }
      break;
    }
  }
};
</script>

<style scoped>
.custom-scrollbar {
  scrollbar-width: thin;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.7);
  border-radius: 9999px;
  border: 2px solid transparent;
  background-clip: content-box;
  transition: background-color 0.2s ease;
}
.custom-scrollbar:hover::-webkit-scrollbar-thumb {
  background-color: rgba(78, 78, 78, 0.9);
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(78, 78, 78, 0.9);
}
.dark .custom-scrollbar {
  scrollbar-color: rgba(54, 54, 54, 0.8) transparent;
}
.light .custom-scrollbar {
  scrollbar-color: rgba(227, 227, 227, 0.8) transparent;
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity 0.3s ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

.backdrop-enter-to,
.backdrop-leave-from {
  opacity: 1;
}
</style>
